// ------------------------------------------------
// -- IMPORTS / LIBRARY-ERWEITERUNGEN
// ------------------------------------------------
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from './store'

import VueLogger from 'vuejs-logger';

import VueRouter from 'vue-router'
import ourRoutes from './routes.js'

import axios from 'axios'
import VueAxios from 'vue-axios'

// Optionen und Verwendung siehe:
// https://github.com/euvl/vue-notification
import Notifications from 'vue-notification'
import infiniteScroll from 'vue-infinite-scroll'

// Liste der hier u.a. verfügbaren Icons:
// https://fontawesome.com/icons?d=gallery&s=solid&m=free
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCoffee } from '@fortawesome/free-solid-svg-icons'
import { faCog }   from '@fortawesome/free-solid-svg-icons'
import { faMinus } from '@fortawesome/free-solid-svg-icons'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faInfo } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-solid-svg-icons'
import { faFilter } from '@fortawesome/free-solid-svg-icons'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import { faHashtag } from '@fortawesome/free-solid-svg-icons'
import { faLayerGroup} from '@fortawesome/free-solid-svg-icons'
import { faListAlt} from '@fortawesome/free-solid-svg-icons'
import { faThList} from '@fortawesome/free-solid-svg-icons'
import { faLongArrowAltRight} from '@fortawesome/free-solid-svg-icons'
import { faChevronLeft} from '@fortawesome/free-solid-svg-icons'
import { faChevronCircleLeft} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import ms from './msclasses/mscore.js'
import mode from './msclasses/mode.js'

library.add(faCoffee)
library.add(faCog)
library.add(faMinus)
library.add(faPlus)
library.add(faUser)
library.add(faShoppingBag)
library.add(faFileDownload)
library.add(faHome)
library.add(faArrowLeft)
library.add(faSpinner)
library.add(faSignOutAlt)
library.add(faTrashAlt)
library.add(faInfo)
library.add(faEnvelope)
library.add(faCircle)
library.add(faFilter)
library.add(faAngleDown)
library.add(faHashtag)
library.add(faLayerGroup)
library.add(faListAlt)
library.add(faThList)
library.add(faLongArrowAltRight)
library.add(faChevronLeft)
library.add(faChevronCircleLeft)


// ------------------------------------------------
// -- CONSTANTS
// ------------------------------------------------
const isProduction = process.env.NODE_ENV === 'production';

// Optionen und Verwendung siehe:
// https://www.npmjs.com/package/vuejs-logger
const loggerOptions = {
  isEnabled: true,
  logLevel : isProduction ? 'error' : 'debug',
  stringifyArguments : false,
  showLogLevel : true,
  showMethodName : true,
  separator: '|',
  showConsoleColors: true
};

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

const router = new VueRouter({
  routes: ourRoutes
});

// ------------------------------------------------
// -- FIREBASE KONFIGURATION
// ------------------------------------------------
/*
Zugangsdaten für Google-Konto / Firebase Console:
https://console.firebase.google.com/
https://console.firebase.google.com/project/ms-leseapp/
User mssoftware45144@gmail.com
Pwd  Rankestr.4-6
*/
//console.log('Firebase '+ process.env.FIREBASE_APIKEY);

/* -ojb, 07.01.2020: Firebase wird nicht mehr verwendet

var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_APIKEY,
  authDomain: process.env.VUE_APP_FIREBASE_PROJECTID + ".firebaseapp.com",
  databaseURL: "https://" + process.env.VUE_APP_FIREBASE_PROJECTID + ".firebaseio.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.VUE_APP_FIREBASE_PROJECTID + ".appspot.com",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_FIREBASE_APPID 
};

// Firebase App (the core Firebase SDK) is always required and
// must be listed before other Firebase SDKs
var firebase = require("firebase/app");

// Add the Firebase products that you want to use
require("firebase/messaging");

// Initialize Firebase
var project = firebase.initializeApp(firebaseConfig, process.env.VUE_APP_ENV_MODE);

//console.log('firebase name is ' + project.name);

Vue.prototype.fcmregistered = false;
if (firebase.messaging.isSupported()) {
  Vue.prototype.fcmsupport = true;
  Vue.prototype.messaging = project.messaging();
  Vue.prototype.messaging.usePublicVapidKey(process.env.VUE_APP_FIREBASE_VAPID);
  navigator.serviceWorker.register(`${process.env.BASE_URL}firebase-messaging-sw.js`, {scope: "firebase-cloud-messaging-push-scope"})  
    .then((registration) => {

      //registration.active.postMessage(JSON.stringify({'foo': process.env.VUE_APP_FIREBASE_MESSAGINGSENDERID}));

      Vue.prototype.messaging.useServiceWorker(registration);
      console.log('Firebase ServiceWorker registered');
      Vue.prototype.fcmregistered = true;
    }).catch(err => {
      console.log('Firebase ServiceWorker: ' + err);
    });
} 
else
  Vue.prototype.fcmsupport = false;

*/  

// navigator.serviceWorker.getRegistrations().then(registrations => {
//   console.log('Registered Service Workers:');
//   console.log(registrations);
// });

// ------------------------------------------------
// -- VUE ERWEITERUNGEN
// ------------------------------------------------
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueLogger, loggerOptions);
Vue.use(VueAxios, axios)
Vue.use(VueRouter);
Vue.use(Notifications)
Vue.use(infiniteScroll);

Vue.use(ms)
Vue.use(mode)

Vue.config.productionTip = false

//console.log("process.env ist " + JSON.stringify(process.env));
//console.log("ENV_NAME ist " + process.env.VUE_APP_ENV_NAME);

// Altes main.js:
//new Vue({
//  router,
//  el: '#app',
//  template: '<App/>',
//  components: { App }
//})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
